import { AbstractDataProviderV2 } from 'components/system/data-provider';
import { CustomerParamsUpdate, RsCustomerParamsInfo } from './types';
import { CustomerParamsPatch } from './types/CustomerParamsPatch';

export class CustomerParamsDataProvider extends AbstractDataProviderV2<{}, RsCustomerParamsInfo, {}, CustomerParamsUpdate, CustomerParamsPatch> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/params');
    }

    list(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    add(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    remove(): Promise<any> {
        return Promise.reject('method is not supported');
    }
}
